import App, { Container } from "next/app";
import Head from "next/head";
import React from "react";
import Router from "next/router";

import "../styles/GridLayoutStyles.css";
import "react-resizable/css/styles.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
import Loading from "../components/Loading";
import GlobalToast from "../components/GlobalToast";

export default class NextApp extends App {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    // Show loading on route change start
    Router.events.on("routeChangeStart", this.handleRouteChangeStart);
    // Hide loading on route change complete
    Router.events.on("routeChangeComplete", this.handleRouteChangeComplete);
    // Hide loading on route change error
    Router.events.on("routeChangeError", this.handleRouteChangeComplete);
  }

  componentWillUnmount() {
    // Clean up event listeners
    Router.events.off("routeChangeStart", this.handleRouteChangeStart);
    Router.events.off("routeChangeComplete", this.handleRouteChangeComplete);
    Router.events.off("routeChangeError", this.handleRouteChangeComplete);
  }

  handleRouteChangeStart = () => {
    this.setState({ loading: true });
  };

  handleRouteChangeComplete = () => {
    this.setState({ loading: false });
  };

  static async getInitialProps({ Component, ctx }) {
    let pageProps = {};
    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx);
    }

    return { pageProps };
  }

  render() {
    const { Component, pageProps } = this.props;
    const { loading } = this.state;

    return (
      <Container>
        <Head>
          <title>NxCast - Smart Board Display</title>
          <link
            rel="icon"
            href="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>📺</text></svg>"
          />
        </Head>
        {loading && <Loading />}
        <Component {...pageProps} />
        <GlobalToast />
      </Container>
    );
  }
}
